import React, { useContext } from 'react';
import { HeaderSwitch } from '@mummssoftware/common-ui';
import { SET_BEREAVEMENT_TABLE } from '../Context/constants';
import { AppBereavementContext } from '../Context/AppBereavementContext';
import { BereavementContext } from '../../context';
import defaults from '../../translations/en.json';

export const BereavementSwitch = () => {
  const { showTable, dispatch } = useContext(AppBereavementContext);
  const { smallWidget } = useContext(BereavementContext);
  const handleToggle = () =>
    dispatch({
      type: SET_BEREAVEMENT_TABLE,
      payload: !showTable,
    });
  return (
    <>
      {!smallWidget && (
        <HeaderSwitch
          isChecked={showTable}
          rightText={defaults.contactSchedule}
          leftText={defaults.hospice}
          onToggle={handleToggle}
        />
      )}
    </>
  );
};
export default BereavementSwitch;
